module.exports = "<div class=\"container\">\n<div class=\"well form-container\">\n  <span class=\"error\" *ngIf=\"error\">{{ error }}</span>\n  <button class=\"login-button\" md-button (click)=\"loginGoogle()\" id=\"google\">Login With Google</button>\n</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// D:/Projects/angular/ecell-hcst/src/app/login/login.component.html
// module id = ../../../../../src/app/login/login.component.html
// module chunks = 1